<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageGuestCategories.title') }}
    </portal>
    <template v-if="guestCategories !== null">
      <card :title="$t('admin.pageGuestCategories.card.guestCategories')" cols="12 6@hd">
        <hm-card-inner v-for="guestCategory in guestCategories"
                       v-if="!guestCategory.deleted"
                       :title="getName(guestCategory)"
                       :deletable="true"
                       :key="guestCategory.id"
                       @delete="deleteGuestCategory(guestCategory)">
          <hm-input-multilang v-model="guestCategory.name"
                              :lazy="true"
                              :label="$t('admin.pageGuestCategories.name')"
                              :system-languages="true" />
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedGuestCategories)" :title="$t('admin.pageGuestCategories.card.deletedGuestCategories')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="guestCategory in deletedGuestCategories"
                              :title="getName(guestCategory)"
                              :clickable="false"
                              :key="guestCategory.id" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageGuestCategories.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageGuestCategories.actions.addGuestCategory')" icon="plus" color="blue" @click="addGuestCategory()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, groupBy, isEmpty, isEqual, isNil, keyBy, map, maxBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageGuestCategories',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'guestCategories',
      variable: 'guestCategories',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        if (isNil(this.guestCategories)) {
          cbSaveComplete();
          return;
        }

        const guestCategories = cloneDeep(this.guestCategories);
        const savedGuestCategoriesMap = isNil(this.savedGuestCategories) ? {} : keyBy(this.savedGuestCategories, 'id');

        guestCategories
          .filter((it) => {
            if (it.deleted) return false;
            if (isNil(savedGuestCategoriesMap[it.id])) return false;
            if (isEqual(savedGuestCategoriesMap[it.id].name, it.name)) return false;
            return true;
          })
          .forEach((it) => {
            this.axios.put(this.serviceUrls.guestCategory.get(this, it.id), it)
              .then((response) => {
                this.showMessages(response);
              })
              .catch((error) => {
                this.showMessages(error.response);
              });
          });

        this.savedGuestCategories = cloneDeep(guestCategories);

        cbSaveComplete();
      },
    },
  ],

  data() {
    return {
      guestCategories: null,
      savedGuestCategories: null,
    };
  },

  computed: {
    deletedGuestCategories: function () {
      return isNil(this.guestCategories) ? null : this.guestCategories.filter(it => it.deleted === true);
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.guestCategory.list(this))
        .then((response) => {
          this.guestCategories = response.data.data;
          this.savedGuestCategories = cloneDeep(this.guestCategories);
          this.$serviceBus.$emit('guestCategory.list', this.guestCategories);
        });
    },
    addGuestCategory() {
      this.axios.post(this.serviceUrls.guestCategory.list(this), {
        name: {
          [this.hotelSettings.details.primaryLanguage]: this.$t('admin.pageGuestCategories.newGuestCategoryName'),
        },
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(guestCategory) {
      const name = isNil(guestCategory) ? null : guestCategory.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (this.hasRole('ROLE_SYSADMIN')) {
        ret = `${ret} <span class="color--gray">(${guestCategory.id})</span>`;
      }

      return ret;
    },
    deleteGuestCategory(guestCategory, confirmed = false) {
      const guestCategoryId = guestCategory.id;
      if (!confirmed) {
        this.showModal(
          this.$t('admin.pageGuestCategories.confirmDeleteGuestCategory', [this.getName(guestCategory)]),
          (doNotShowAgain) => {
            this.deleteGuestCategory(guestCategory, true);
          },
        );
      } else {
        this.axios.delete(this.serviceUrls.guestCategory.get(this, guestCategoryId))
          .then((response) => {
            this.loadData();
            this.$serviceBus.$emit('hotelSettings.update');
            this.showSuccessMessage();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageGuestCategories.vue